import { AppInfoMessage, InsuranceParamsPropertyDataDto, PersonAdditionalData, User, VehicleDto } from "."
import { InsuranceParamsTypes } from "../enums/InsuranceParamsTypes"
import { PagedGrid } from "./Shared/PagedGrid"
import { PagedQuery } from "./Shared/PagedQuery"


export interface PoleasQuery extends InsuranceParamsVehiclePagedQuery {
    importId?: number
    leasingNumber?: string
    offerState?: ImportInsuranceStates
    dateImportedFrom?: Date
    dateImportedTo?: Date
    dateAccessFrom?: Date
    dateAccessTo?: Date
    dateInsuranceStartFrom?: Date
    dateInsuranceStartTo?: Date
}

export interface InsuranceParamsVehiclePagedQuery extends InsuranceParamsPagedQuery {
    registrationMark?: string
    vin?: string
    contractAcceptationTypeId?: number
    insuranceParamsType?: InsuranceParamsTypes
    showPoleas?: boolean
}

export interface InsuranceParamsPagedGrid
    extends PagedGrid<InsuranceParamsGridItem | InsuranceParamsVehicleGridItem | InsuranceParamsPoleasGridItem | InsuranceParamsPropertyGridItem> { }

export interface ShortInsurancePagedGrid {
    totalCount: number
    items: ShortInsuranceGridItem[]
}

export interface AppInfoPagedGrid {
    totalCount: number
    items: AppInfoMessage[]
}

export interface InsuranceParamsPagedQuery extends PagedQuery {
    listType?: number
    dateCreatedFrom?: Date
    dateCreatedTo?: Date
    dateContractedFrom?: Date
    dateContractedTo?: Date
    legalPersonIdentification?: string
    legalPersonName?: string
    insuranceParamsId?: string
    insurerId?: number
    ouId?: number
    contractStateId?: number
    contractNumber?: string
    export?: boolean
    showItemsToDelete?: boolean
    userId?: string
    userCity?: string
    userStreet?: string
    createdById?: string
    anniversaryFrom?: Date
    anniversaryTo?: Date
}

export interface InsuranceParamsPoleasGridItem extends InsuranceParamsVehicleGridItem {
    importId?: number
    lastClientAccess?: string
    lastError?: string
    leasingNumber: string
    state?: ImportInsuranceStates
    stateText?: string
    clientDisabled?: boolean
    clientDisableReason?: string
    importName: string
    lastChange?: Date
}


export type ParamsStateType = 'created' | 'toSend' | 'printed' | 'sent' | 'Contracted' | string

export interface InsuranceParamsGridItem {
    insuranceParamsId: number
    step?: number
    startDate?: Date
    dateCreated?: Date
    createdBy?: User
    name?: string
    note?: string
    insurerId?: number
    insurerFullName?: string
    offerId?: number
    contractNumber?: string
    contractCreatedDate?: Date
    contractAcceptationType: number
    type: number
    policyHolder?: PersonAdditionalData
    client?: PersonAdditionalData
    contractCanceled?: boolean,
    contractCanceledById?: string,
    contractCanceledDate?: Date,
    exported?: boolean
    paramsState?: ParamsStateType
    paramsStateText?: string
}



export interface InsuranceParamsVehicleGridItem extends InsuranceParamsGridItem {
    vehicle: VehicleDto
}

export interface InsuranceParamsPropertyGridItem extends InsuranceParamsGridItem {
    data: InsuranceParamsPropertyDataDto
}

export interface ShortInsuranceGridItem {
    contractNumber: string
    insuranceStartDate: Date | null
    insuranceEndDate: Date | null
    vin: string
    makeBase: string
    modelBase: string
    contractCreatedDate: Date | null
    createdBy: User | null
    id: number
}

export interface HistoryItem {
    actionType: string
    type?: ActionHistoryTypes
    dateCreated: Date
    userId: string
    firstName: string
    lastName: string
    fullName: string
    ouId: number
    ouName: string
    offerId?: number
}

export enum ActionHistoryTypes {
    CreatedBusinessCase = 1,
    SelectedOffer = 2,
    CreateContract = 3,
    ChangeVehicleEmail = 4,
    CalculationSummary = 5,
    GdprAnonymizationAutomat = 6,
    GdprAnonymizationManual = 7,
    ContractReactivation = 8,
    ContractCancelAcceptation = 9,
    ImportInsuranceExport = 10,
    ShortInsurance = 11,
    EmailVehicleChange = 12,
    EmailContractStorno = 13,
    EmailCalculation = 14,
    EmailCalculationGdpr = 15,
    EmailContract = 16,
    EmailContractGdpr = 17,
    EmailResetPassword = 18,
    EmailDiscountRequest = 19,
    EmailVehicleInspectionRequest = 20,
    EmailPublicAccess = 21,
    EmailPpzAuthorizationCreated = 22,
    EmailPpzAuthorizationApproved = 23,
    EmailPpzAuthorizationExpires = 24,
    EmailPaymentNotification = 25,
    EmailCsobDiscountNotification = 26,
    EmailAPIExceededCountOfQueries = 27,
    ProvisionDateSet = 28
}

export enum ImportInsuranceStates {
    WaitingToSend = 1,
    UrlNotClicked = 2,
    UrlClicked = 3,
    ClientLoggedIn = 4,
    ChangedByClient = 5,
    Contracted = 6,
    ContractedByClient = 7,
    Error = -1,
    Valid = 0,
    ClientDisabled = 1000
}

export const defaultDateFrom = (() => {
    // 1. den v minulem mesici

    let result = new Date()
    result.setDate(1)
    result.setMonth(result.getMonth() - 1)

    return result
})()